import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export const Checkbox = (props) => {
  const { checked } = props;
  return (
    <div className="at-checkbox-container">
      <input type="checkbox" className="at-checkbox-hidden-inp" {...props} />
      <div className={classNames("at-checkbox", { "at-checkbox--checked": checked })}>
        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3px">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
    </div>
  );
};

Checkbox.propTypes = {};
